import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Container,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@mui/material';
import {
  Add as AddIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { VendorList } from 'Components/vendors/VendorList';
import { VendorForm } from 'Components/vendors/VendorForm';
import { useAuthTenant } from 'store/auth';

/**
 * VendorsPage Component
 * Main page for vendor management
 */
export const VendorsPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const { t } = useTranslation(['vendor', 'common']);

  // Get tenant from Redux store
  const selectedTenant = useSelector(useAuthTenant);

  const handleOpenForm = (vendor = null) => {
    setSelectedVendor(vendor);
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setSelectedVendor(null);
  };

  const handleFormSuccess = () => {
    handleCloseForm();
  };

  return (
    <Container maxWidth="xl">
      <Box py={4}>
        {/* Page Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Box>
            <Typography variant="h4" gutterBottom>
              {t('vendor:list.title')}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {t('vendor:list.subtitle')}
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleOpenForm()}
            size="large"
          >
            {t('vendor:form.title.add')}
          </Button>
        </Box>

        {/* Vendor List */}
        <VendorList
          onEdit={handleOpenForm}
          tenant={selectedTenant?.slug}
        />

        {/* Vendor Form Dialog */}
        <Dialog
          open={isFormOpen}
          onClose={handleCloseForm}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">
                {selectedVendor ? t('vendor:form.title.edit') : t('vendor:form.title.add')}
              </Typography>
              <IconButton onClick={handleCloseForm}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent>
            <VendorForm
              vendor={selectedVendor}
              onSuccess={handleFormSuccess}
              onCancel={handleCloseForm}
            />
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  );
};
